import { render, staticRenderFns } from "./ModuleTitle.vue?vue&type=template&id=7d81f22d&"
import script from "./ModuleTitle.vue?vue&type=script&lang=js&"
export * from "./ModuleTitle.vue?vue&type=script&lang=js&"
import style0 from "./ModuleTitle.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports